export const setReloadFinancialYear = (reload) => ({
    type: 'RELOAD_FY',
    payload: reload
});
export const setReloadQuery = (reload) => ({
    type: 'RELOAD_QUERY',
    payload: reload
});
export const setReloadClient = (reload) => ({
    type: 'RELOAD_CLIENT',
    payload: reload
});
export const setReloadUser = (reload) => ({
    type: 'RELOAD_USER',
    payload: reload
});
export const setReloadComment = (reload) => ({
    type: 'RELOAD_COMMENT',
    payload: reload
});
export const setReloadDocument = (reload) => ({
    type: 'RELOAD_DOCUMENT',
    payload: reload
});
export const setReloadFolder = (reload) =>({
    type: 'RELOAD_FOLDER',
    payload: reload
});
